
import drawerStore from '../pageStores/DrawerStore.js'    
import Voucher from './voucher.js' 
import SelfSettlementStore from './selfSettlementStore'
export default {
    voucherStore:new Voucher,
    selfSettlementStore:new SelfSettlementStore(),
    drawerStore:drawerStore
}